<template>
  <div style="height: 100%">
    <v-snackbar
      v-model="snackbar.show"
      top
      :timeout="4000"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar.show = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-row justify="center">
      <v-col cols="12" lg="10" md="10" sm="12" xs="12">
        <track-title :title_group="trackTitle" class="mb-6" />
        <papers-table :papers="trackPapers" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TrackTitle from "@/components/atoms/TitleGroup.vue";
import PapersTable from "@/components/organisms/PapersTable.vue";

export default {
  props: ["trackId"],
  components: {
    TrackTitle,
    PapersTable,
  },
  computed: {
    papers() {
      return this.$store.getters.papers || [];
    },
    trackPapers() {
      return this.papers.filter((paper) => paper.trackId == this.trackId);
    },
    tracks() {
      return this.$store.getters.getTracks || [];
    },
    currentTrack() {
      return this.tracks.find((track) => track.id == this.trackId);
    },
    trackTitle() {
      let lang = this.$i18n.locale;

      return this.currentTrack.content[lang].title || "";
    },
    user() {
      return this.$store.getters.getUser;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    snackbar() {
      return this.$store.state.snackbar.snackbar;
    },
  },
  async created() {
    if (!this.$store.getters.papers) await this.$store.dispatch("getPapers");

    if (!this.$store.getters.getTracks) await this.$store.dispatch("getTracks");
  },
  beforeMount() {
    //only mount for allowed users
    if (!this.isAdmin && !this.user.tracks?.includes(this.trackId))
      this.$router.push("/");
  },
};
</script>